import { useRef, cloneElement } from 'react'

import { useVirtualizer } from '@tanstack/react-virtual'

import InfiniteScroll from '@/components/Grid/components/Table/InfiniteScroll'

const ESTIMATED_ITEM_HEIGHT = 100

export default function Virtualizer({ children, rows, total, hasMore, onVisit }) {
  const ref = useRef(null)

  const virtualizer = useVirtualizer({
    count: total,
    getScrollElement: () => ref.current,
    estimateSize: () => ESTIMATED_ITEM_HEIGHT,
    overscan: 5,
  })

  return <div ref={ref} className='h-[68vh] max-h-[68vh] overflow-auto'>
    <div className='relative w-full' style={{ height: virtualizer.getTotalSize() }}>
      {virtualizer.getVirtualItems().map(virtualItem => <div
        ref={virtualizer.measureElement}
        key={virtualItem.key}
        data-index={virtualItem.index}
        className='absolute top-0 left-0 w-full'
        style={{ transform: `translateY(${virtualItem.start}px)` }}
      >
        {cloneElement(children, { row: rows[virtualItem.index] })}
      </div>)}
      {hasMore ? <div className='absolute w-full' style={{ top: virtualizer.getTotalSize() }}>
        <InfiniteScroll onVisit={onVisit} hasMore={hasMore} />
      </div> : null}
    </div>
  </div>
}
